import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12.5 23C6.70085 23 2 18.2992 2 12.5C2 6.70085 6.70085 2 12.5 2C18.2992 2 23 6.70085 23 12.5C23 18.2992 18.2992 23 12.5 23ZM7.77433 15.1378C7.77595 15.2757 7.80472 15.4119 7.859 15.5387C7.96874 15.7946 8.17668 15.9964 8.43522 16.0998C8.69376 16.2032 8.98278 16.1996 9.2387 16.09L12.5945 14.6515C13.1741 14.4037 13.55 13.8335 13.55 13.2035V7.25C13.55 6.97152 13.4394 6.70445 13.2425 6.50754C13.0455 6.31063 12.7785 6.2 12.5 6.2C12.2215 6.2 11.9545 6.31063 11.7575 6.50754C11.5606 6.70445 11.45 6.97152 11.45 7.25V12.857L8.4113 14.1601C8.2845 14.2143 8.16962 14.293 8.07324 14.3916C7.97685 14.4903 7.90084 14.6069 7.84956 14.735C7.79827 14.863 7.77271 14.9999 7.77433 15.1378Z"
    fillRule="evenodd"
  />,
  'FilledClockIcon',
)
